import React, { useMemo } from 'react'
import { TimelineEventTrack } from '../../../../../CommonComponents/timeline/Timeline'
import useAssets from '../../../hooks/useAssets'
import useSelectedGroupSatellite from '../../../hooks/useSelectedGroupSatellite'
import { ContactTaskSvg, GeoFeatureSvg, TargetTrackSvg } from '../../../../../CommonComponents/svgs/Svgs'
import Event from '../Event'
import ContactsOverlay from './ContactsOverlay'
import FeaturesOverlay from './FeaturesOverlay'

const OrbitalEvents = () => {

    const { orbitalInsights } = useAssets()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()

    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const selectedOrbitalInsights = useMemo(() => (selectedSatellite && orbitalInsights?.data) ? orbitalInsights?.data[selectedSatellite] : null, [orbitalInsights.data, selectedSatellite])
    const Contacts = useMemo(() => selectedOrbitalInsights?.allOrbits?.groundStationPasses || [], [selectedOrbitalInsights?.allOrbits?.groundStationPasses])
    const Features = useMemo(() => selectedOrbitalInsights?.allOrbits?.geoFeaturePasses || [], [selectedOrbitalInsights?.allOrbits?.geoFeaturePasses])

    return (
        <TimelineEventTrack>
            {Contacts.map((event, index) => {
                const { startTime, endTime, groundStationName } = event
                const icon = <ContactTaskSvg />
                const uniqueid = `contact-${index}`
                return (
                    <Event key={uniqueid}
                        icon={icon}
                        endTime={endTime}
                        eventName={groundStationName}
                        startTime={startTime}
                        allEvents={Contacts}
                        className={`orbital__events `}
                        overlay={ContactsOverlay}
                    />
                )
            })}
            {Features.map((event, index) => {
                const { startTime, endTime, geoFeatureName, geoFeatureType } = event
                const icon = geoFeatureType === "Geofence" ? <GeoFeatureSvg /> : <TargetTrackSvg className='target__svg' />
                const uniqueid = `feature-${index}`
                return (
                    <Event key={uniqueid}
                        icon={icon}
                        endTime={endTime}
                        eventName={geoFeatureName}
                        startTime={startTime}
                        allEvents={Features}
                        className={`orbital__events`}
                        overlay={FeaturesOverlay}
                    />
                )
            })}
        </TimelineEventTrack>
    )
}

export default OrbitalEvents